// Currency localization — display-only.
// Stripe still charges GBP; this converts £ → local for the UI.
// Live rates come from backend /api/fx/rates (cached 24h server-side); static fallback used on failure.

import { fx } from "./api";

const STATIC_RATES_FROM_GBP = {
  GBP: 1.0,
  USD: 1.27,
  EUR: 1.18,
  CAD: 1.73,
  AUD: 1.94,
  INR: 106.0,
  NGN: 1950.0,
  ZAR: 23.8,
  JPY: 194.0,
  SGD: 1.72,
  AED: 4.67,
  CHF: 1.12,
  BRL: 7.5,
  MXN: 22.5,
};

let liveRates = null;
let liveFetchPromise = null;

const LOCALE_TO_CURRENCY = {
  US: "USD", CA: "CAD", GB: "GBP", IE: "EUR", AU: "AUD", NZ: "AUD",
  IN: "INR", NG: "NGN", ZA: "ZAR", JP: "JPY", SG: "SGD", AE: "AED",
  CH: "CHF", BR: "BRL", MX: "MXN",
  FR: "EUR", DE: "EUR", ES: "EUR", IT: "EUR", NL: "EUR", BE: "EUR",
  PT: "EUR", FI: "EUR", GR: "EUR", AT: "EUR",
};

export function detectCurrency() {
  try {
    const lang = navigator.language || "en-GB";
    const parts = lang.split("-");
    const region = (parts[1] || "").toUpperCase();
    if (region && LOCALE_TO_CURRENCY[region]) return LOCALE_TO_CURRENCY[region];
    const f = new Intl.NumberFormat().resolvedOptions();
    if (f.locale) {
      const r = (f.locale.split("-")[1] || "").toUpperCase();
      if (r && LOCALE_TO_CURRENCY[r]) return LOCALE_TO_CURRENCY[r];
    }
  } catch { /* ignore */ }
  return "GBP";
}

export async function loadFxRates() {
  if (liveRates) return liveRates;
  if (liveFetchPromise) return liveFetchPromise;
  liveFetchPromise = fx.rates()
    .then((data) => { liveRates = data?.rates || null; return liveRates; })
    .catch(() => null);
  return liveFetchPromise;
}

function rateFor(currency) {
  if (liveRates && liveRates[currency]) return liveRates[currency];
  return STATIC_RATES_FROM_GBP[currency] || null;
}

export function convertFromGBP(amountGBP, toCurrency) {
  const rate = rateFor(toCurrency);
  if (!rate) return null;
  return amountGBP * rate;
}

export function formatMoney(amount, currency) {
  try {
    return new Intl.NumberFormat(navigator.language || "en-GB", {
      style: "currency",
      currency,
      maximumFractionDigits: amount < 10 ? 2 : 0,
    }).format(amount);
  } catch {
    return `${currency} ${amount.toFixed(2)}`;
  }
}
